import {Form} from 'semantic-ui-react';

function FormInput(props) {
  const {input, required, label, fluid, type, size, meta: {touched, error}} = props;
  const id = props.id || input.name;
  const placeholder = props.placeholder || label;
  const exactLabel = ['.', '?', '!', '؟'].includes(label.charAt(label.length - 1));

  return (
    <Form.Input
      {...input}
      fluid={fluid}
      id={id}
      label={exactLabel ? label : `${label} :`}
      required={required}
      placeholder={placeholder}
      type={type}
      size={size}
      error={(touched && error != null) ? error : false}
    />
  );
}

FormInput.defaultProps = {fluid: true};

export default FormInput;
